import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";

import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import CorporateSolutions from "@/pages/CorporateSolutions";
import Testimonials from "@/pages/Testimonials";
import Instructor from "@/pages/Instructor";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyCourses from "@/pages/MyCourses";
import MyCourseDetail from "@/pages/MyCourseDetail";
import EnrollmentForm from "@/pages/EnrollmentForm";
import VerifyCertificate from "@/pages/VerifyCertificate";

import AdminLayout from "@/pages/Admin/AdminLayout";
import AdminDashboard from "@/pages/Admin/AdminDashboard";
import AdminCourses from "@/pages/Admin/AdminCourses";
import AdminBlog from "@/pages/Admin/AdminBlog";
import AdminTestimonials from "@/pages/Admin/AdminTestimonials";
import AdminContact from "@/pages/Admin/AdminContact";
import AdminStudents from "@/pages/Admin/AdminStudents";
import AdminCertificates from "@/pages/Admin/AdminCertificates";
import AdminSettings from "@/pages/Admin/AdminSettings";
import AdminEnrollments from "@/pages/Admin/AdminEnrollments";

function useCanonical() {
  const location = useLocation();
  useEffect(() => {
    const url = `https://zbcampus.com${location.pathname}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [location.pathname]);
}

function PublicLayout() {
  useCanonical();
  return (
    <>
      <Navbar />
      <main data-testid="page-content">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public + Auth pages share navbar/footer */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/egitimler" element={<Courses />} />
              <Route path="/egitim/:slug" element={<CourseDetail />} />
              <Route path="/kurumsal-cozumler" element={<CorporateSolutions />} />
              <Route path="/yorumlar" element={<Testimonials />} />
              <Route path="/egitmen" element={<Instructor />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/iletisim" element={<Contact />} />
              <Route path="/giris" element={<Login />} />
              <Route path="/kayit" element={<Register />} />
              <Route path="/egitimlerim" element={<ProtectedRoute><MyCourses /></ProtectedRoute>} />
              <Route path="/egitimlerim/:courseId" element={<ProtectedRoute><MyCourseDetail /></ProtectedRoute>} />
              <Route path="/kayit-formu" element={<EnrollmentForm />} />
              <Route path="/dogrula/:certificateId" element={<VerifyCertificate />} />
            </Route>

            {/* Admin */}
            <Route path="/admin" element={
              <ProtectedRoute adminOnly>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<AdminDashboard />} />
              <Route path="egitimler" element={<AdminCourses />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="yorumlar" element={<AdminTestimonials />} />
              <Route path="iletisim" element={<AdminContact />} />
              <Route path="kayit-formlari" element={<AdminEnrollments />} />
              <Route path="ogrenciler" element={<AdminStudents />} />
              <Route path="sertifikalar" element={<AdminCertificates />} />
              <Route path="ayarlar" element={<AdminSettings />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
